import Form from '../modules/form'
import DOMReady from '../utils/DOMReady'

// eslint-disable-next-line no-unused-vars
import css from '../../css/blocks/contact-form.scss'

class ContactForm {
  constructor(el) {
    this.container = el
    this.formEl = this.container.querySelector('.form')

    if (this.form !== null) {
      this.form = new Form(this.formEl)
    }
  }
}

DOMReady(() => {
  const elements = document.querySelectorAll('.contact-form')
  if (elements !== null) {
    elements.forEach(element => new ContactForm(element))
  }
})
